import Btn from 'components/buttons/Btn'
import { isArray } from 'lodash-es'
import PropTypes from 'prop-types'
import Collapse from 'react-bootstrap/Collapse'
import { useTranslation } from 'react-i18next'
import { klass, useBoolState } from 'utils'

/**
 * Similar to <details>, but customizable and actually animated.
 * @param actionTxts {array} A list of two strings, for show/hide states. Defaults to "More/Less details"
 * @param className
 * @param mb {number} margin-bottom, that gets compensated at the top
 * @param show {boolean} Initial state
 * @param onToggle {function(boolean)} Additional operation to run during toggling
 * @param children
 * @return {JSX.Element}
 * @TODO make all those explanatory Detail entries get their own perm state boolean (instead of cookie?) and maybe give it a better style, like a left border and maybe an (i) icon on the open/close handle?
 */
export default function Details({ actionTxts, className, mb = 0, show = false, onToggle, children }) {
	const { t } = useTranslation()
	const state = useBoolState(show)

	actionTxts ||= [t('More details'), t('Less details')]

	function doToggle() {
		state.toggle()
		onToggle && onToggle(state.is)
	}

	return <div className={className}>
		<Collapse in={state.is}>
			<div>{children} {/* the div must be the single child and is needed to proper animate the height */}</div>
		</Collapse>

		<div {...klass(`mb-${mb}`, { textRight: state.is, [`mt-n${mb}`]: !state.is })}>
			<Btn variant="link" size="sm" className="px-0" onClick={doToggle}>
				{state.is? '▲ ' + actionTxts[1] : '▼ ' + actionTxts[0]}
			</Btn>
		</div>
	</div>
}

Details.propTypes = {
	mb       : PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
	className: PropTypes.string,
	show     : PropTypes.bool,
	onToggle : PropTypes.func,
	children : PropTypes.node.isRequired,

	actionTxts: (props, name, component) => {
		if (!props[name]) {
			return //undefined is allowed
		}
		if (!isArray(props[name])) {
			return new Error(`Invalid prop '${name}' of type '${typeof props[name]}' supplied to '${component}', expected 'array(2)'`)
		}
		if (props[name].length != 2) {
			return new Error(`Invalid array length of ${props[name].length} for '${name}' supplied to '${component}', expected 2`)
		}
	},
}
